import React from 'react';
import StatisticsView from '../../components/StatisticsView';

function StatistikPage() {
  return <StatisticsView />;
}

export default StatistikPage;
